import { TokenInfo } from '@labb/constellation-core-types';

export enum SingpassStatus {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export interface SingpassUserData {
  name?: string;
  gender?: 'M' | 'F';
  dateOfBirth?: string; // yyyy-MM-dd
  nationality?: string; // 2-letter country code e.g. 'SG'
  nric?: string; // NRIC is the unique identifier given to all Singapore Citizens and Permanent Residents
  fin?: string; // FIN is the unique identifier for Foreigners.
  finPassExpiryDate?: string; // This refers to the pass expiry date of a FIN holder.
  uinfin?: string; // NRIC number or FIN of user. This is the raw value we get from Singpass
  employerName?: string;
  address?: {
    line1?: string;
    line2?: string;
    city?: string;
    postcode?: string;
    country?: string; // 2-letter country code e.g. 'SG'
  };
}

export interface SingpassCodesResponse {
  clientState?: string;
  applicationId: string;
}

export type SingpassResult = {
  caseId: string;
  status: SingpassStatus;
  userData?: SingpassUserData;
  error?: string;
  errorDescription?: string;
};

export type SingpassClientState = {
  urlSearchParams: string;
  pegaToken: TokenInfo;
  csrfToken?: string;
};
